export const topLeagues = [
  { name: "Premier League", country: "england" },
  { name: "La Liga", country: "spain" },
  { name: "Bundesliga", country: "germany" },
  { name: "Serie A", country: "italy" },
  // { name: "Ligue 1", country: "france" },
  // { name: "Primeira Liga", country: "portugal" },
  // { name: "UEFA Champions League", country: "World" },
  // { name: "UEFA Europa League", country: "World" },
];
